/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
import React from "react";

import { Fade } from "react-awesome-reveal";

import Button from "../elements/Button";
import { useLanguage } from "../contexts/LanguageContext.js";

import BuildWebsite from "../assets/images/hero/farmer.png";

export default function Hero() {
  const { t } = useLanguage();

  return (
    <section className="hero">
      <div className="w-full lg:w-1/2 xl:pl-12 sm:pr-2 mt-8">
        <h1 className="text-5xl sm:text-6xl text-white font-bold leading-tight mb-5">
          {t('heroTitle')}
        </h1>

        <p className="font-bold text-xl text-white leading-relaxed mb-16">
          {t('heroSubtitle')}
        </p>
        <Fade direction="up" delay={500} triggerOnce>
          <Button
            href="/project"
            type="link"
            className="flex w-80 h-12 items-center px-14 py-5 text-white text-xl  bg-green-900 rounded-full border-2 border-green-700 hover:bg-green-900 transition duration-200"
          >
            {t('heroButton')}
            <svg
              className="ml-2 w-7 h-7 text-white animate-bounce-x"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M9 5l7 7-7 7"
              />
            </svg>
          </Button>
        </Fade>
      </div>
      <div className="flex pt-5 md:w-fit w-full justify-center items-center order-first md:order-first lg:order-last lg:w-1/2">
        <Fade direction="up" triggerOnce>
          <img className="" src={BuildWebsite} alt="Build Website" />
        </Fade>
      </div>
    </section>
  );
}
